import React, { Component } from "react";
import Changepassword from "./Changepassword"
import Navbar from '../navbar/topnav'
import StaticLeftNav from '../navbar/StaticLeftNav'
import UserPanel from './UserPanel.js'
import Preferences from './Preferences.js'
import {verifyCognitoJWT} from '../Login/Token.js'
import {TryAgain} from '../Alert/CommonNotices' 
import "./Account.css";

export default class Account extends Component {
  constructor(props) {
    super(props);

    this.state = {
      apiPending: false,
      alertMsg: "",
      userInfo: undefined,
    };
    this.closeAlert = this.closeAlert.bind(this);
    this.redirecting = this.redirecting.bind(this)
    this.props.breadCrumb([{display:'Site List', click:this.redirecting}, 
      {display: 'Account', click:undefined}])
  }
  componentDidMount() {
    const prom = verifyCognitoJWT (this.props.authToken)
    prom.then ((userInfo) =>{
      this.setState({userInfo: userInfo})
    }) 
  }
  redirecting () {
    this.props.clearCrumb()
    this.props.history.push("/")
  }
  validateForm() {
    return this.state.oldpassword.length > 4 && this.state.password.length > 4 && 
           (this.state.password.localeCompare(this.state.confirmpassword) === 0);
  }

  loginButtonDisabled () {
    return false;
    //return !this.validateForm() || this.state.apiPending;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value,
      apiPending: false
    });
  }

  closeAlert () {
    this.setState({alertShown: false});
  }

  render() {
    try {
      return (
        <div className="content-container">
        <Navbar {...this.props} />
        <StaticLeftNav {...this.props} />
        <div className="main-pane alt-background">
          <Changepassword {...this.props} redirect={this.redirecting}/>
          <UserPanel {...this.state.userInfo}/>
          <Preferences {...this.props}/>
        </div>
      </div>
      );
    }
    catch (err){
      console.log (err)
      return (<TryAgain details={"Myaccount.render: "+err.toString()} />)
    }
  }
}

